import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import * as constants from '../constants';
import { mapFilterOptionsToStore } from '../utils/vehicleFilters';

export default {
  namespaced: true,
  state: {
    categoriesPath: [],
    categories: [],
    conditions: [],
    boards: [],
    board: [],
    hotspots: [],
    searchData: {},
    searchDataCurrent: {},
    vehicleData: JSON.parse(localStorage.getItem(constants.LEVEL4_VEHICLE_DATA)) || {},
    vehicleCurrentFilters: {},
    ...mapFilterOptionsToStore(constants.vehicleFiltersBasicTypes),
    ...mapFilterOptionsToStore(constants.vehicleFiltersVehicleTypes),
  },
  getters,
  actions,
  mutations,
};
